import axios from 'axios'
import qs from 'qs'

import {msgAlert} from './message'
import xml2js from 'xml2js'

//store全局数据
import {store} from './store'

// 超时时间
axios.defaults.timeout = 30000;
// 错误信息
let errMsg = '';

//定义一个请求拦截器，发送请求之前
axios.interceptors.request.use(config=> {
  store.commit('loading');  
  config.headers.token = window.localStorage.getItem('accessToken') ? window.localStorage.getItem('accessToken') : '';
  return config;
}, err=> {
  errMsg = '请求超时！';
  store.commit('showing');
  handleError(errMsg);
  return Promise.resolve(err);
  //return Promise.reject(error);
})
//定义一个响应拦截器
axios.interceptors.response.use(data=> {
  store.commit('showing');
  if (data.status && data.status == 200 && data.data.status == 'error') {
    console.log(data.data.retMsg)
    //msgAlert.error(data.data.retMsg);
    return;
  }
  return data;
}, err=> {
  store.commit('showing');
  if(err.response) {
    if (err.response.status == 504||err.response.status == 404) {
      errMsg = '服务器请求地址不存在！';      
    } else if (err.response.status == 403) {
      errMsg = '403权限不足,请联系管理员！';      
    } else if (err.response.status == 406) {
      errMsg = '406操作失败！';      
    } else {
      errMsg = '服务器请求故障！';      
    }
  } else {
    errMsg = '服务器请求故障！';    
  }
  handleError(errMsg);
  console.log(err);
  return Promise.resolve(err);
})
function handleError(info) {
  console.log(info)
  unityPopwin(info)
  //msgAlert.error(info)
}
//unity弹窗提示
function unityPopwin(info) {
  //console.log(typeof(popup_window));
  // typeof popup_window === "function" ? popup_window(info) : false;
}
let base = '';
export const handleRequest = (url, params, type, success, fail) => {  
  let rq;
  if(url.indexOf('.json') != -1) {
    type = 'get';
  }
  if(type && type == 'post') {
    rq = postRequest(url, params);
  } else if(type && type == 'file') {
    rq = uploadFileRequest(url, params);
  } else {
    rq = getRequest(url, params);
  }
  rq.then(function(response) {
    if(response && response.data) {
      let resdata = typeof(response.data) == 'string' ? JSON.parse(response.data) : response.data;
      if(response.headers && response.headers['content-type'].indexOf("/xml") != -1) {  //XML
        xml2js.parseString(resdata, function (err, result) {
          if(!err) {
            if(success) {
              let retdata = typeof(result.string._) == 'string' ? JSON.parse(result.string._) : result.string._;
              success(retdata);
            }
          } else {
            if(fail) {
              console.log('xml2js', err);
              fail(resdata);
            }
          }
        });
      } else if(typeof(resdata.isSuccess) != 'undefined') {
        if(resdata.isSuccess) {
          if(success) {
            success(resdata);
          } else {
            console.log(resdata)
            //msgAlert.success(resdata.retMsg);
          }
        } else if(resdata.code == 403) {  //登录验证
          //
        } else {
          if(fail) {
            fail(resdata);
          }
          console.log(resdata.retMsg)
        }
      } else {  //
        if(success) {
          success(resdata);
        }
      }
    }
    })
    .catch(function(error) {
      store.commit('showing');
      console.log('catch：'+error);
      //msgAlert.error('未知错误!');
    });
}

export const postRequest = (url, params) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    /*transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],*/
    headers: {
      //'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}
export const uploadFileRequest = (url, params) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
export const putRequest = (url, params) => {
  return axios({
    method: 'put',
    url: `${base}${url}`,
    data: params,
    /*transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],*/
    headers: {
      //'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}
export const deleteRequest = (url, params) => {
  /*return axios({
    method: 'delete',
    url: `${base}${url}`,
    data: params
  });*/
  axios.delete(`${base}${url}`, {
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export const getRequest = (url, params) => {
  /*return axios({
    method: 'get',
    url: `${base}${url}`,
    data: params
  });*/
  return axios.get(`${base}${url}`, {
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

function GetUrlParam(paraName) {　　　　
    var url = document.location.toString();　　　　
    var arrObj = url.split("?");
    if(arrObj.length > 1) {　　　　　　
        var arrPara = arrObj[1].split("&");　　　　　　
        var arr;　
        for(var i = 0; i < arrPara.length; i++) {　　　　　　　　
            arr = arrPara[i].split("=");　　　　　
            if(arr != null && arr[0] == paraName) {　　　　　　　　　　
                return arr[1];　　　　　　　　
            }　　　　　　
        }　　　　　　
        return "";　　　　
    }　　　　
    else {　　　　　　
        return "";　　　　
    }　　
}



// WEBPACK FOOTER //
// ./src/utils/request.js